import { render, staticRenderFns } from "./FormModalPhone.vue?vue&type=template&id=4bf5039c&scoped=true"
import script from "./FormModalPhone.vue?vue&type=script&lang=js"
export * from "./FormModalPhone.vue?vue&type=script&lang=js"
import style0 from "./FormModalPhone.vue?vue&type=style&index=0&id=4bf5039c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf5039c",
  null
  
)

export default component.exports